import type { McpTool } from '../../types/api-types';
import StyledTooltip from '../../../../../components/tooltip';

type McpToolCardProps = {
  tool: McpTool;
  isDisabled: boolean;
  onToggle: () => void;
};

function McpToolCard({ tool, isDisabled, onToggle }: McpToolCardProps) {
  const description = tool.description?.trim() || 'No description available';

  return (
    <div
      className={`group flex items-center justify-between gap-2 px-2 py-1.5 rounded-md min-w-0 w-full cursor-pointer transition-all duration-200 ease-in-out ${
        isDisabled
          ? 'hover:bg-slate-50 opacity-80 hover:opacity-100'
          : 'hover:bg-slate-100 hover:shadow-sm'
      }`}
    >
      <StyledTooltip
        title={description}
        placement="top"
        maxWidth={300}
        tooltipBgColor="#434B51"
        enterDelay={200}
        leaveDelay={0}
      >
        <div className="flex items-center gap-1.5 min-w-0 flex-1">
          <span className="text-xs font-medium text-gray-800 truncate transition-colors duration-200 group-hover:text-slate-700">
            {tool.name}
          </span>
          {tool.has_widget && (
            <span className="text-[10px] px-1.5 py-0.5 rounded bg-orange-100 text-orange-700 shrink-0 transition-opacity duration-200 group-hover:opacity-90">
              Widget
            </span>
          )}
        </div>
      </StyledTooltip>
      <span
        className="mcpSwitch shrink-0"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
        role="presentation"
      >
        <input type="checkbox" checked={!isDisabled} onChange={onToggle} />
        <span className="mcpSlider round" />
      </span>
    </div>
  );
}

export default McpToolCard;
